import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const LanguageContext = createContext();

export const LANGUAGES = {
  FR: 'fr',
  EN: 'en'
};

export const LanguageProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Determine language from URL
  const getLanguageFromPath = (pathname) => {
    return pathname.startsWith('/en') ? LANGUAGES.EN : LANGUAGES.FR;
  };

  const [language, setLanguageState] = useState(() => getLanguageFromPath(location.pathname));

  // Update language when URL changes
  useEffect(() => {
    const newLang = getLanguageFromPath(location.pathname);
    setLanguageState(newLang);
  }, [location.pathname]);

  // Switch language and navigate to equivalent page
  const switchLanguage = (newLang) => {
    const currentPath = location.pathname;
    let newPath;

    if (newLang === LANGUAGES.EN) {
      // Switching to English
      if (currentPath === '/') {
        newPath = '/en';
      } else if (!currentPath.startsWith('/en')) {
        newPath = '/en' + currentPath;
      } else {
        newPath = currentPath;
      }
    } else {
      // Switching to French
      if (currentPath === '/en' || currentPath === '/en/') {
        newPath = '/';
      } else if (currentPath.startsWith('/en/')) {
        newPath = currentPath.replace('/en', '');
      } else {
        newPath = currentPath;
      }
    }

    navigate(newPath);
  };

  const isEnglish = language === LANGUAGES.EN;
  const isFrench = language === LANGUAGES.FR;

  return (
    <LanguageContext.Provider value={{ 
      language, 
      switchLanguage, 
      isEnglish, 
      isFrench,
      LANGUAGES 
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
